import { Alert, Button, Card, Form, Input, Space } from 'antd'
import { useGeckoLocale } from 'features/locale'
import styled from 'styled-components'

import { InspectionMethodsEditor } from './InspectionMethodsEditor'
import {
  InspectionArea,
  InspectionAreaUpdate,
  PlanningAreasConfig,
} from './planningTypes'
import { TechniqueCatalogue } from './techniqueTypes'

const AreaCard = styled(Card)<{ $selected: boolean }>`
  outline: ${({ theme, $selected }) =>
    $selected ? `2px solid ${theme.forecast.activeText}` : 'none'};
  outline-offset: 2px;
`

export const InspectionAreaCard = ({
  area,
  titleLabel,
  config,
  catalogue,
  sourceRequiredArea,
  readonly,
  saving,
  selected,
  geometryError,
  canRedraw,
  canShow,
  onSelect,
  onChange,
  onShow,
  onRedraw,
  onDelete,
}: {
  area: InspectionArea
  titleLabel: string
  config: PlanningAreasConfig
  catalogue: TechniqueCatalogue
  sourceRequiredArea: number | undefined
  readonly: boolean
  saving: boolean
  selected: boolean
  geometryError: string | undefined
  canRedraw: boolean
  canShow: boolean
  onSelect: () => void
  onChange: (update: InspectionAreaUpdate) => void
  onShow: () => void
  onRedraw: () => void
  onDelete: () => void
}) => {
  const { measurementSystem } = useGeckoLocale()
  return (
    <AreaCard
      $selected={selected}
      title={area.title}
      aria-current={selected ? 'true' : undefined}
      onClick={onSelect}
      extra={
        <Space onClick={(event) => event.stopPropagation()}>
          {canShow && <Button onClick={onShow}>Show</Button>}
          {!readonly && (
            <>
              {area.scope !== 'zone' && (
                <Button disabled={saving || !canRedraw} onClick={onRedraw}>
                  Redraw
                </Button>
              )}
              <Button danger disabled={saving} onClick={onDelete}>
                Delete
              </Button>
            </>
          )}
        </Space>
      }>
      {geometryError && <Alert type='warning' showIcon title={geometryError} />}
      <div onClick={(event) => event.stopPropagation()}>
        <InspectionMethodsEditor
          area={area}
          catalogue={catalogue}
          config={config.methodPlanning}
          measurementSystem={measurementSystem}
          sourceRequiredArea={sourceRequiredArea}
          disabled={readonly || saving}
          onChange={onChange}
        />
        <Form.Item htmlFor={`${area.id}-title`} label={titleLabel} required>
          <Input.TextArea
            id={`${area.id}-title`}
            autoSize
            value={area.title}
            disabled={readonly || saving}
            onChange={(event) => onChange({ title: event.target.value })}
          />
        </Form.Item>
      </div>
    </AreaCard>
  )
}
